import usePageMeta from "@/hooks/usePageMeta";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Services } from "@/components/site/Services";
import { Woodcraft } from "@/components/site/Woodcraft";
import { Projects } from "@/components/site/Projects";
import { Process } from "@/components/site/Process";
import { QuoteForm } from "@/components/site/QuoteForm";
import { Contact, Footer } from "@/components/site/Contact";
import { FloatingWhatsApp } from "@/components/site/FloatingWhatsApp";

export default function Home() {
  usePageMeta(
    "TSR Industry | CNC Machining, Laser & Plasma Cutting, Teak Woodwork – Machilipatnam",
    "TSR Industry, Machilipatnam, Andhra Pradesh: CNC machining, turning & milling, iron, plasma & laser cutting, CNC wood routing, custom fabrication, teak lotus flowers, pooja mandirs, wooden panels and furniture. Request a quotation."
  );
  return (
    <div data-testid="home-page" className="overflow-x-clip">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <Woodcraft />
        <Projects />
        <Process />
        <QuoteForm />
        <Contact />
      </main>
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
}
